import React, { useEffect } from "react";
import caseStudyDetails from "../../data/caseStudyDetails.json";
import { useParams } from "react-router-dom";
import CaseStudyDownloadForm from "../../componets/Form2";
import MBGPage from "../MBGPage";

const Section2 = () => {
  const { title } = useParams();
  // console.log(title);

  if (title === "mbg") {
    console.log("if cond");
    return <MBGPage />;
  }
  

  const caseStudy = caseStudyDetails.find(
    (study) => study.companyName.toLowerCase() === title.toLowerCase()
  );

  // console.log(caseStudy);
  return (
    <section className="w-[95%] lg:w-[95%] xl:w-[90%] h-auto pt-[180px] pb-[50px] md:pb-[100px] md:pt-[100px] flex flex-col gap-10 justify-evenly items-center m-auto ">
      <div className="w-full flex flex-col md:flex-row justify-center items-center gap-10">
        <div className=" w-[90%] md:w-[50%] xl:w-[35%] h-auto flex flex-col gap-10 justify-evenly">
          <div className="text-4xl text-red-500">
            <h2>{caseStudy.title}</h2>
          </div>
          <div className="flex flex-col gap-4">
            <h3 className="capitalize text-2xl text-gray-600 ">Introduction</h3>
            <p>{caseStudy.introduction}</p>
          </div>
          <div className="flex flex-col gap-4">
            <h3 className="capitalize text-2xl text-gray-600">Challenges</h3>
            <p>{caseStudy.challenges}</p>
          </div>
        </div>
        <div className="w-[90%] md:w-[50%] xl:w-[35%] flex flex-col justify-center gap-5 h-full ">
          <h1 className=" text-[14px] font-medium md:text-lg md:font-base text-red-600">
            Download The Case Study Now To Learn More About This Remarkable
            Transformation.
          </h1>
          <CaseStudyDownloadForm fileLink={caseStudy.file} />
        </div>
      </div>
    </section>
  );
};

export default Section2;
